module.exports = __webpack_public_path__ + "img/编辑2.d7421eb6.svg";